import axios from 'axios';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import MilestonesApp from './MilestonesApp';
import './i18nextConf';
import { attachRequestId } from './api/requestId';
import { store } from './store';
import UserContextProvider from './context/UserContext';

attachRequestId(axios);

ReactDOM.render(
  <Provider store={store}>
    <UserContextProvider>
      <MilestonesApp />
    </UserContextProvider>
  </Provider>,
  document.getElementById('root')
);
